export default __webpack_public_path__ + "static/media/nuvama-white-logo.5cfe2603.svg";